import React from 'react';
import SEO from '../components/SEO';

const TermsOfService = () => {
  return (
    <div className="py-16 bg-white">
      <SEO 
        title="Terms of Service - Trademark Flux"
        description="Read Trademark Flux terms of service. Understand our service agreements, user responsibilities, and legal terms for using our trademark registration services."
        keywords="terms of service, service agreement, legal terms, trademark flux terms"
      />
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              <strong>Last Updated:</strong> January 2025
            </p>

            <p className="text-gray-600 mb-6">
              Please read these Terms of Service carefully before using Trademark Flux's services. By accessing or using our services, you agree to be bound by these terms.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-600 mb-4">
                By using Trademark Flux's services, you agree to these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Services</h2>
              <p className="text-gray-600 mb-4">
                Trademark Flux provides trademark registration, copyright registration, trademark search, company formation, and related intellectual property services. We act as an intermediary to prepare and file documents with appropriate government agencies.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. No Attorney-Client Relationship</h2>
              <p className="text-gray-600 mb-4">
                Trademark Flux is not a law firm and does not provide legal advice. Our services do not create an attorney-client relationship. For legal advice, please consult with a licensed attorney.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. User Responsibilities</h2>
              <p className="text-gray-600 mb-4">You are responsible for:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Providing accurate and complete information</li>
                <li>Ensuring you have the right to register the trademark</li>
                <li>Responding to communications from government agencies</li>
                <li>Paying all government filing fees and service fees</li>
                <li>Maintaining the security of your account credentials</li>
                <li>Complying with all applicable laws and regulations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Fees and Payments</h2>
              <p className="text-gray-600 mb-4">
                Service fees are clearly disclosed before purchase. Government filing fees are separate and non-refundable. All fees must be paid before services are rendered unless otherwise agreed.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. No Guarantee of Approval</h2>
              <p className="text-gray-600 mb-4">
                We cannot guarantee that your trademark application will be approved by the USPTO or other government agencies. Approval depends on various factors including availability of the mark and compliance with legal requirements.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Refund Policy</h2>
              <p className="text-gray-600 mb-4">
                Service fees may be refundable before work has commenced. Government filing fees are non-refundable. Refund requests must be submitted in writing and will be evaluated on a case-by-case basis.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Intellectual Property Rights</h2>
              <p className="text-gray-600 mb-4">
                All content on this website, including text, graphics, logos, and software, is the property of Trademark Flux or its licensors and is protected by copyright and trademark laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Limitation of Liability</h2>
              <p className="text-gray-600 mb-4">
                To the fullest extent permitted by law, Trademark Flux shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Indemnification</h2>
              <p className="text-gray-600 mb-4">
                You agree to indemnify and hold Trademark Flux harmless from any claims, damages, losses, and expenses arising from your use of our services or violation of these terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Termination</h2>
              <p className="text-gray-600 mb-4">
                We reserve the right to terminate or suspend your access to our services at any time, with or without notice, for conduct that we believe violates these Terms of Service or is harmful to other users or our business.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Changes to Terms</h2>
              <p className="text-gray-600 mb-4">
                We reserve the right to modify these Terms of Service at any time. Your continued use of our services after changes are posted constitutes acceptance of the modified terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Governing Law</h2>
              <p className="text-gray-600 mb-4">
                These Terms of Service are governed by the laws of the United States and the state in which Trademark Flux operates, without regard to conflict of law principles.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Contact Information</h2>
              <p className="text-gray-600 mb-4">
                If you have any questions about these Terms of Service, please contact us at:
              </p>
              <p className="text-gray-600">
                Email: legal@trademarkflux.com<br />
                Phone: +1 (800) 123-4567
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;